import { Component, OnInit, ViewChild } 							from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } 	    from '@angular/forms';
import { ErrorStateMatcher } 										from '@angular/material/core';

import { Router, ActivatedRoute } 								    from '@angular/router';
import { first } 												    from 'rxjs/operators';

import { AlertService, BatchService } 					    	    from '../_services';

import { Subject } 													from 'rxjs';
import { Observable,throwError } 									from 'rxjs';
import { Globals }                                                  from '../_helpers';


@Component({
  selector: 'app-home',
  templateUrl: './batch-detail.component.html'
})

export class BatchdetailComponent implements OnInit {

	loading = false;
    submitted = false;
    errorMsg : string;
    returnUrl: string;
    batch_name: string;
    training_partner: string;
    training_center: string;
    location: string;
    total_student: string;
    assessment_date: string;
    reporting_time: string;
    localData = {};
    activeExam = {};    
    feedbacksetting: number = 0;
    center_id: string;
    scheme_type: string;
    scheme_name: string;
    sub_scheme_name: string;
    viva_assessor: number
    viva_pc: number = 0;
    practical_viva: number = 0;
    allowExamType: number = 0;
    examid:number = 0;
        
  	constructor(
        private route: ActivatedRoute,
        private router: Router,
        private batchService: BatchService,
        private alertService: AlertService,
        private globals: Globals,
    ) {}

  	ngOnInit() {
    	this.localData = JSON.parse(localStorage.getItem('currentUser'));
        this.activeExam = JSON.parse(localStorage.getItem('activeExam_PS'));
        if(sessionStorage.pkshn_assor_feedback != undefined)
        {
            this.feedbacksetting = sessionStorage.pkshn_assor_feedback; 
        }
        this.viva_assessor = this.activeExam['viva_assessor'];
        this.viva_pc = this.activeExam['vivapc'];
        this.practical_viva = this.activeExam['viva_practical'];
        this.examid = this.activeExam['exam_id'];        
        // get return url from route parameters or default to '/'
        this.returnUrl = '/';

        /* Call on load function */
        this.getBatchData();
    }


    private getBatchData(){
		this.submitted = true;
		this.batchService.getBatchDetails(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.localData['exam_id'])
        .pipe(first())
        .subscribe(
	        data => {
                if(data.code == 1000){
                	let batch = data.batches;
            		this.batch_name = batch.batch_name;
					this.training_partner = batch.traning_partner;
					this.training_center = batch.traning_center;
					this.location = batch.location;
					this.total_student = batch.no_student;
					this.assessment_date = batch.date_assessment;
					this.reporting_time = batch.repoting_time;
                    this.center_id = batch.center_id;
                    this.scheme_type = batch.scheme_type;
                    this.scheme_name = batch.scheme_name;
                    this.sub_scheme_name = batch.sub_scheme_name;
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.loading = false;
                }
	        },
	        error => {
	            this.alertService.error(error);
	            this.loading = false;
	        }
	    );
	}
    public gotoDashboard(){
       this.router.navigateByUrl('/home/' + this.examid+'/'+this.viva_assessor+'/'+this.viva_pc+'/'+this.practical_viva);
    }     
    public gotoFeedback(){
        this.router.navigateByUrl('/start-feedback'); 
    }         
}
